<template>
  <content-with-sidebar data-v-sticky-container>
    <!-- content -->
    <div class="blog-detail-wrapper pb-1 pt-1 pr-1 pl-0 ml-0">
      <b-spinner v-if="loading" class="align-middle mr-1 my-2" variant="secondary"></b-spinner>
      <b-row class="mr-0">
        <b-col cols="12" lg="12">
          <b-card class="mb-2">
            <b-card-title style="cursor:pointer" class="mb-0">{{news.title}}</b-card-title>
            <div>
              <small class="text-muted">by <span style="color:black">{{news.user.NAME}}</span> | {{news.datefix}}</small>
            </div> 
            <div class="mt-1 ml-0">
              <b-badge pill class="mr-1" variant="primary">
                {{news.category.name}}
              </b-badge>
              <b-badge pill class="mr-1" variant="primary">
                {{news.product.PRODUCT}}
              </b-badge>
            </div>

            <b-card-text class="mt-2">
              <div class="mb-1" v-html="news.body"></div>
              <b-form v-if="news.file.length > 0" style="margin-bottom:5px" inline>
                <feather-icon class="inline-form-custom-select-pref" icon="PaperclipIcon" size="12" />
                <label for="inline-form-custom-select-pref">Attachment</label>
              </b-form>
              <b-card-text v-for="attach in news.file" :key="attach.id" class="border border-danger font-weight-bolder rounded bold" style="padding:5px;font-size:0.8rem;">
                <b-row>
                  <b-col class="txt-xs" sm="6">
                    <span style="line-height:3vh;margin-left:5px"
                      ><feather-icon size="14" icon="FileTextIcon" />
                      <span style="color:red; padding-left:5px;">{{attach.files.replace("files/discussion/", " ")}}</span>
                    </span>
                  </b-col>
                  <b-col class="txt-xs font-weight-lighter" sm="6">
                    <span class="mr-3" style="line-height:3vh"> {{toMB(attach.size)}} MB</span>
                    <span style="line-height:3vh">
                      {{attach.datefix}}
                    </span>
                    <span>
                      <b-link target="_blank" :href="attach.file_url">
                        <b-button
                          class="txt-xs-2 float-right"
                          size="sm"
                          variant="primary"
                        >
                          <span
                            ><feather-icon size="14" icon="DownloadIcon" />
                            Download
                          </span>
                        </b-button>
                      </b-link>
                    </span>
                  </b-col>
                </b-row>
              </b-card-text>
              <hr/>
              <span>
                <feather-icon style="margin-bottom:3px;margin-left:10px" icon="EyeIcon" size="12" /> {{news.seen.length}}
                <feather-icon style="margin-bottom:3px;margin-left:10px" icon="ThumbsUpIcon" size="12" /> {{news.like.length}}
              </span>
              <b-link class="card-link float-right">
                <b-button
                  class="txt-xs-2"
                  size="md"
                  variant="outline-primary"
                  :disabled="loading"
                  @click="likes()"
                >
                  <span><feather-icon size="14" icon="ThumbsUpIcon" />
                    Likes
                  </span>
                </b-button>
              </b-link>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      
      <b-row class="mr-0">
        <b-col cols="12" lg="12">
            <h4>Comment</h4>
            <b-card>
              <b-col class="text-center" v-if="!newsComments.length && !loading">
                <b-card>
                  <b-card-text>
                    <h3 class="text-muted">No comments yet</h3>
                  </b-card-text>
                </b-card>
              </b-col>
              <div v-for="(commentItem,key) in newsComments" :key="commentItem.id">
                <b-media no-body>
                  <b-media-aside class="mr-75">
                    <b-avatar
                      rounded-circle
                      size="42"
                      :src="`https://pwb.telkom.co.id/index.php?r=pwbPhoto/profilePhoto&nik=`+commentItem.user.USERNAME"
                    />
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{commentItem.user.NAME}}
                    </h6>
                    <small>{{commentItem.datefix}}</small>
                    <b-card-text>
                      <div class="mt-1 mb-1">{{commentItem.comment}}</div>
                    </b-card-text>
                  </b-media-body>
                </b-media>
                <hr v-if="key != Object.keys(newsComments).length - 1">
              </div>
            </b-card>
            <b-spinner v-if="loading" class="align-middle mr-1 my-2" variant="secondary"></b-spinner>
        </b-col>
      </b-row>
      <b-pagination
        v-if="newsComments.length > 0"
        v-model="currentPage"
        :total-rows="pagination.total"
        :per-page="perPage"
        first-number
        last-number
        class="mb-0 mt-1 mt-sm-0"
        align="center"
        prev-class="prev-item"
        next-class="next-item"
        @input="changePage"
      >
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>

      <b-row class="mb-2 mr-0">
        <b-col cols="12" lg="12">
            <h4>Leave a comment</h4>
            <b-card>
              <b-form-textarea
                id="textarea-default"
                placeholder="Comment"
                rows="3"
                v-model="comment"
              />
              <b-button
                class="txt-xs-2 mt-2 float-right"
                size="md"
                variant="primary"
                :disabled="loading"
                @click="sendComment()"
              >
                <span>
                  Comment
                </span>
              </b-button>
            </b-card>
        </b-col>
      </b-row>
    </div>
    <!--/ content -->

    <!-- sidebar -->
    <div slot="sidebar" class="blog-sidebar m-1" v-sticky="options">
      <!-- categories -->
      <div class="blog-categories" :class="{ topstick: !showNavbar }">
        <div class="mb-2">
          <b-button v-tracker="'button:new-topic'" variant="primary" class="w-100" :to="{ name: 'discussion-create' }">
            Start New Topic
          </b-button>
        </div>
        <b-card class="mb-4">
          <b-card-title class="mb-2">Hot Topics</b-card-title>

          <b-col
            cols="12"
            class="mt-2 pl-0"
            v-for="(topic,key) in hotTopics.data" :key="topic.id"
          >
            <b-link class="card-link" style="color:#6e6b7b" @click="detail(topic.discussion.id)">{{topic.discussion.title}}</b-link>
            <b-progress
              :value="topic.count"
              :max="hotTopics.total"
              height="6px"
              :variant="variantTopic(key)"
            />
          </b-col>
        </b-card>
      </div>
      <!--/ categories -->
    </div>
  </content-with-sidebar>
</template>

<script>
import { BSpinner,BFormTextarea,BMedia,BMediaAside,BMediaBody,BForm,BBadge,BProgress,BCardTitle,BCardBody,BFormInput,BAvatar,BLink,BCardText,BCard, BContainer, BRow, BCol, BPagination, BButton } from 'bootstrap-vue'
import ContentWithSidebar from '@core/layouts/components/content-with-sidebar/ContentWithSidebar.vue'
import DCard from '@/views/user/discussion/Cards.vue'
import vSelect from 'vue-select'

export default {
  components: {
    BSpinner,
    BFormTextarea,
    BMediaBody,
    BMedia, 
    BMediaAside,
    BForm,
    BBadge,
    BProgress,
    BCardTitle,
    BCardBody,
    BFormInput,
    BAvatar,
    ContentWithSidebar,
    BCardText,
    BCard,
    BLink,
    BContainer,
    BRow,
    BCol,
    BButton,
    DCard,
    BPagination,
    vSelect,
  },

  data() {
    return {
      comment: '',
      hotTopics: [],
      loading: true,
      showNavbar: true,
      lastScrollPosition: 0,
      otherNews: {},
      news: {
        user: {
          name : ''
        },
        category: {
          name : ''
        },
        product: {
          PRODUCT : ''
        },
        file : [],
        like : [],
        seen : []
      },
      newsComments: [],
      avatar: require('@/assets/images/portrait/small/avatar-s-9.jpg'),
      options: {
        topSpacing: 0,
        bottomSpacing: 0,
        containerSelector: '[data-v-sticky-container]',
        innerWrapperSelector: '[data-v-sticky-inner]',
        resizeSensor: false, // [1] read above
        stickyClass: 'is-affixed',
        minWidth: 0,
      },
      perPage: 5,
      currentPage: 1,
      pagination: {
        from: 1,
        to: 9,
        total: 0,
      },
      searchWord: '',
      selected: { title: 'All' },
      option: [{ title: 'All' }, { title: 'Rectangle' }, { title: 'Rombo' }, { title: 'Romboid' }],
    }
  },

  filters: {
    truncate: function(value, length, start = 0) {
      if (!value) return ''
      value = value.toString()
      if (value.length > length) {
        if (start > 0) {
          return value.substring(start, length + start) + '...'
        } else {
          return value.substring(start, length) + '...'
        }
      } else {
        return value
      }
    },
  },

  watch: {
    currentPage() {
      this.fetchComment()
    },
  },

  created(){
    
  },
  
  mounted() {
    this.fetchNews()
    this.fetchComment()
    this.fetchHotTopics()
    window.addEventListener('scroll', this.onScroll)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },

  methods: {
    variantTopic(key){
      switch (key) {
        case 1:
          return 'warning';
          break;
        case 2:
          return 'success';
          break;
        case 3:
          return 'danger';
          break;
      
        default:
          return '';
          break;
      }
    },
    fetchHotTopics(){
      this.$http
        .get('/discussion/getListHotTopics', {
        })
        .then(({ data }) => {
          this.hotTopics = data
        })
    },
    detail(id){
      window.location.href = 'http://localhost:8080/discussion/'+id
      // window.location.href = 'https://productcatalog.telkom.co.id/discussion/'+id
      // this.$router.push({name : 'discussion-detail', params:{key:id}})
    },
    likes(){
      this.loading = true
      this.$http
      .post('/discussion/likes', {
          discussion_id: this.$route.params.key,
      })
      .then(() => {
          this.$notif('Success', 'Liked', 'success', 'InfoIcon', 3000)
          this.comment = ''
          this.fetchNews()
      })
      .catch(({ data }) => {
          this.$notif('Warning', `${data.message}`, 'warning', 'InfoIcon', 3000)
      })
      .finally(() => {
          this.loading = false
      })
    },
    sendComment(){
      this.loading = true
      this.$http
      .post('/discussion/comment', {
          discussion_id: this.$route.params.key,
          comment: this.comment
      })
      .then(() => {
          this.$notif('Success', 'Comment successfully submited.', 'success', 'InfoIcon', 7000)
          this.comment = ''
          this.fetchComment()
      })
      .catch(({ data }) => {
          this.$notif('Error', `${data.message}`, 'error', 'InfoIcon', 3000)
      })
      .finally(() => {
          this.loading = false
      })
    },
    toMB(bytes) {
      let mb = bytes * 0.000001
      return mb.toFixed(2)
    },
    fetchComment() {
      this.loading = true
      this.$http
        .get(`/discussion/detail_comment/${this.$route.params.key}`, {
          params: {
            page: this.currentPage,
            perPage: this.perPage,
          },
        })
        .then(({ data }) => {
          this.currentPage = data.current_page
          this.pagination.total = data.total
          this.pagination.from = data.from
          this.pagination.to = data.to
          this.newsComments = data.data
          this.loading = false
        })
    },
    fetchNews() {
      this.loading = true
      this.$http
        .get(`/discussion/detail/${this.$route.params.key}`, {})
        .then(({ data }) => {
          this.news = data
          this.loading = false
        })
    },
    changePage(page) {
      this.currentPage = page
    },
    onScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition < 0) {
        return
      }
      // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
        return
      }

      this.showNavbar = currentScrollPosition < 120
      this.lastScrollPosition = currentScrollPosition
    },
  },
}
</script>

<style>
.topstick {
  margin-top: 3vh;
}

.card-img, .card-img-top, .card-img-bottom {
  height: calc(104.35vh/1.7);
}
@media only screen and (max-width: 600px) {
  .inner-wrapper-sticky {
    position: relative !important;
    left: 0;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>